<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <ul class="cont bs">
        <router-link tag="li" to class="flex" v-for="(item,i) in 6" :key="i">
          <div class="left">
            <div class="demo-type inline">
              <el-avatar :size="50" @error="errorHandler">
                <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
              </el-avatar>
            </div>
            <div class="info inline">
              <div class="top">
                系统通知
                <span class="time">2018-8-20 10:20:20</span>
              </div>
              <p>平台体验优化有奖调查！VIP免费送！</p>
            </div>
          </div>
          <div class="right">浏览: 18888</div>
        </router-link>
      </ul>
      <el-pagination
        background
        :page-size="pageSize"
        :total="totalCount"
        :page-count="totalPage"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="prevPage"
        @next-click="nextPage"
        layout="total, sizes,prev, pager, next,  jumper"
      ></el-pagination>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";

export default {
  name: "notice",
  data() {
    return {
      // pageIndex: 1,
      pageSize: 10, // 每页显示个数
      totalPage: 10, // 总页数
      totalCount: 20, // 总条目数
      currentPage: 1 // 当前页
    };
  },
  components: {
    HeadCom,
    FooterCom
  },
  methods: {
    errorHandler() {
      return true;
    },
    // 每页数
    handleSizeChange(val) {
      console.log(val);
    },
    // 当前页
    handleCurrentChange(val) {
      console.log(val);
    },
    // 上一页
    prevPage() {
      console.log("上一页");
    },
    // 下一页
    nextPage() {
      console.log("下一页");
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-pagination{
  text-align: center !important;
}
.cont {
  border-radius: 6px;
  margin: 30px 0 0 30px;
  padding: 20px;
  background: #ffffff;
  li {
    padding: 20px 0;
    border-bottom: 1px solid #dddddd;
    &:last-child {
      border-bottom: none;
    }
  }
  .info {
    margin-left: 10px;
    line-height: 26px;
    .time {
      font-size: 14px;
      margin-left: 10px;
    }
  }
}
</style>
